<div class="modal-container transition-all">
  <!-- Backdrop -->
  @if (hasModals()) {
    <div [@backdropAnimation]
         [style.z-index]="getBackdropZIndex()"
         class="modal-backdrop">
    </div>
  }

  <!-- Modals -->
  @for (modal of activeModals(); track modal.id) {
    <div [@modalAnimation]
         [style.z-index]="getModalZIndex($index)"
         class="modal-wrapper">
      <div class="modal-content-wrapper">
        @if (isLoading()) {
          <div class="absolute inset-0 flex items-center justify-center z-50">
            <mypart-spinner-loading></mypart-spinner-loading>
          </div>
        }
        <div [ngClass]="{'blur-sm': isLoading()}">
          <ng-container [ngComponentOutletInputs]="modal.inputs"
                        [ngComponentOutlet]="modal.component">
          </ng-container>
        </div>
      </div>
    </div>
  }
</div>
